import { render, staticRenderFns } from "./diagnostic-rule-manager.vue?vue&type=template&id=f5655660&scoped=true&"
import script from "./diagnostic-rule-manager.vue?vue&type=script&lang=js&"
export * from "./diagnostic-rule-manager.vue?vue&type=script&lang=js&"
import style0 from "./diagnostic-rule-manager.vue?vue&type=style&index=0&id=f5655660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5655660",
  null
  
)

export default component.exports